import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getLocalizedItems } from '@/plugins/i18n'
import { getTranslatedItems } from '@/plugins/i18n'

import { useGetOrFetchAsync } from '@/composables/store'

import { orderApi } from '@/apis/order.api'

export const useOrderStore = defineStore('order', () => {
  const api = orderApi
  const orderStatuses = ref([
    { id: 0, name: 'common.transmissionStatus.notSent' },
    { id: 5, name: 'common.transmissionStatus.sent' },
    { id: 20, name: 'common.transmissionStatus.received' },
    { id: 60, name: 'common.transmissionStatus.inProgress' },
    { id: 65, name: 'common.transmissionStatus.partiallyShipped' },
    { id: 80, name: 'common.transmissionStatus.partiallyCanceled' },
    { id: 90, name: 'common.transmissionStatus.shipped' },
    { id: 94, name: 'common.transmissionStatus.canceledByDealer' },
    { id: 95, name: 'common.transmissionStatus.canceledByManufacturer' },
    { id: 99, name: 'common.transmissionStatus.completed' },
    { id: -1, name: 'common.transmissionStatus.error' },
  ])

  const supplierOrderRowImportActions = ref([
    {
      id: 0,
      name: 'common.cancel'
    },
    {
      id: 1,
      name: 'common.add'
    },
  ])
  const supplierOrderGroups = ref([])
  const supplierOrderReasons = ref([])

  const fetchSupplierOrderGroupsAsync = async(force = false, params) => useGetOrFetchAsync(supplierOrderGroups, () => orderApi.getSupplierOrderGroupsAsync(params), force)
  const fetchSupplierOrderReasonsAsync = async(force = false) => useGetOrFetchAsync(supplierOrderReasons, () => orderApi.getSupplierOrderReasonsAsync(), force)

  const getLocalizedOrderStatuses = () => getLocalizedItems(orderStatuses.value)
  const getLocalizedSupplierOrderGroups = () => getTranslatedItems(supplierOrderGroups.value)
  const getLocalizedSupplierOrderReasons = () => getTranslatedItems(supplierOrderReasons.value)

  const $reset = () => {
    supplierOrderReasons.value = []
  }

  return {
    api,
    supplierOrderGroups,
    supplierOrderReasons,
    supplierOrderRowImportActions,
    getLocalizedOrderStatuses,
    getLocalizedSupplierOrderGroups,
    getLocalizedSupplierOrderReasons,
    fetchSupplierOrderGroupsAsync,
    fetchSupplierOrderReasonsAsync,
    $reset
  }
}, {
  persist: [
    {
      pick: [
        'supplierOrderReasons',
        'supplierOrderGroups',
      ],
      storage: localStorage
    }
  ]
})
